import Joi from 'joi';

const addressComponentSchema = Joi.object({
  country: Joi.string().required(),
  state: Joi.string().required(),
  city: Joi.string().required(),
  area: Joi.string().required(),
  pincode: Joi.number().optional(),
  coordinates: Joi.array().items(Joi.number()).length(2).optional(),
});

export const validateLookupLocationHierarchy = {
  body: Joi.object({
    addressComponents: addressComponentSchema.required(),
  }),
};

export const validateCreateLocationHierarchy = {
  body: Joi.object({
    addressComponents: addressComponentSchema.required(),
    userId: Joi.string().optional(),
  }),
};